import { createSlice } from '@reduxjs/toolkit';

const firebaseSlice = createSlice({
    name: 'firebase',
    initialState: {
        isLoading: true,
        isAuthenticated: false,
        user: null,
        error: null,
    },
    reducers: {
        loginRequest: (state) => { state.isLoading = true; },
        loginSuccess: (state, action) => {
            state.isLoading = false;
            state.isAuthenticated = true;
            state.user = action.payload;
        },
        loginFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        logout: () => firebaseSlice.getInitialState(),
    },
});

export const { loginRequest, loginSuccess, loginFailure, logout } = firebaseSlice.actions;
export default firebaseSlice.reducer;
